<div class="row">
  <div class="col-12">
    <nb-card>
      <nb-card-header>
        <div class="header-container">
          <h4>Card UID Management</h4>
          <div class="header-actions">
            <button 
              nbButton 
              status="success" 
              size="small" 
              class="me-3" 
              (click)="openRegisterUserDialog()"
            >
              <nb-icon icon="person-add-outline"></nb-icon>
              Register User
            </button>
            <button 
              nbButton 
              status="primary" 
              outline 
              size="small" 
              class="btn-refresh" 
              (click)="toggleAutoRefresh()"
            >
              <nb-icon [icon]="autoRefresh ? 'pause-circle-outline' : 'play-circle-outline'"></nb-icon>
              {{ autoRefresh ? 'Auto-refresh ON' : 'Auto-refresh OFF' }}
            </button>
          </div>
        </div>
      </nb-card-header>
      
      <nb-card-body>
        <!-- Store Selection -->
        <div class="store-selection mb-4">
          <label class="label">Select Store:</label>
          <div class="select-container">
            <!-- Use a native HTML select element instead of nb-select -->
            <select 
              class="form-select custom-select"
              [(ngModel)]="storeId" 
              (change)="onStoreChange()"
              [disabled]="loading"
            >
              <option value="" disabled>Select Store</option>
              <option *ngFor="let store of stores" [value]="store._id">
                {{ store.name }}
              </option>
            </select>
            
            <button 
              nbButton 
              status="primary" 
              size="small" 
              [disabled]="loading || !storeId"
              (click)="loadRecentCardUIDs()"
              class="load-button"
              nbTooltip="Load Store Data"
            >
              <nb-icon icon="refresh-outline"></nb-icon>
            </button>
          </div>
          
          <!-- Debug info -->
          <div *ngIf="stores && stores.length > 0" class="debug-info">
            <small class="text-muted">{{stores.length}} stores available</small>
            <small *ngIf="storeId" class="text-info"> | Selected store ID: {{storeId}}</small>
          </div>
          <div *ngIf="stores && stores.length === 0" class="debug-info">
            <small class="text-danger">No stores available</small>
          </div>
        </div>
        
        <!-- Loading Spinner -->
        <div *ngIf="loading" class="loading-container">
          <nb-spinner status="primary"></nb-spinner>
          <span>Loading card data...</span>
        </div>
        
        <!-- Error Message -->
        <nb-alert *ngIf="error && !loading" status="danger">{{ error }}</nb-alert>
        
        <!-- Card UIDs Table -->
        <div *ngIf="!loading && !error && recentCardUIDs.length > 0" class="card-uid-table-container">
          <nb-card class="card-uid-table">
            <nb-card-body>
              <table>
                <thead>
                  <tr>
                    <th>Card UID</th>
                    <th>Read Time</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let card of recentCardUIDs">
                    <td><code>{{ card.uid }}</code></td>
                    <td>{{ formatTimestamp(card.createdAt) }}</td>
                    <td>
                      <nb-badge 
                        [text]="(card.isLinked || card.isLinkedToUser) ? 'Linked' : 'Unlinked'" 
                        [status]="(card.isLinked || card.isLinkedToUser) ? 'success' : 'warning'"
                        position="top right">
                      </nb-badge>
                    </td>
                    <td>
                      <!-- Show link button for unlinked cards -->
                      <button 
                        *ngIf="!card.isLinked && !card.isLinkedToUser"
                        nbButton 
                        status="primary" 
                        size="small" 
                        (click)="openLinkDialog(card.uid)">
                        Link to User
                      </button>
                      
                      <!-- Show user info for linked cards -->
                      <div *ngIf="card.isLinked || card.isLinkedToUser" class="linked-user-info">
                        <ng-container *ngIf="card.linkedUser || getLinkedUser(card.uid) as user; else loadingUser">
                          <strong>{{ card.linkedUser?.name || user?.fullName || 'User' }}</strong>
                          <small *ngIf="user?.email">{{ user.email }}</small>
                        </ng-container>
                        <ng-template #loadingUser>
                          <span>
                            <nb-icon icon="person"></nb-icon> Linked to User
                          </span>
                        </ng-template>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              
              <!-- Pagination -->
              <div *ngIf="totalItems > pageSize" class="pagination-container">
                <nb-pagination
                  [limit]="pageSize"
                  [boundaryLinks]="true"
                  [totalItems]="totalItems"
                  [page]="currentPage"
                  (pageChange)="onPageChange($event)">
                </nb-pagination>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
        
        <!-- No Data Message -->
        <nb-alert *ngIf="!loading && !error && recentCardUIDs.length === 0" status="info">
          No recent card UIDs found for this store. Present a card to a reader to see it here.
        </nb-alert>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
</ngx-spinner> 